import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance/axiosInstance";
import { ApiErrorResponse } from "../../../api/types/ApiErrorResponse";
import { toApiError } from "../../../api/utils/errorHandling";
import { AdminUserActivityResponse } from "../contracts/AdminUserActivityResponse";
import { mapResponseToAdminUserActivity } from "../mappers/AdminUserActivityMapper";
import { AdminUserActivity } from "../models/AdminUserActivity";

/** The activation activity of an instructor's organization (back office). */
export const fetchAdminUserActivity = createAsyncThunk<
  AdminUserActivity,
  string,
  { rejectValue: ApiErrorResponse }
>("admin/fetchUserActivity", async (instructorId, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get<AdminUserActivityResponse>(
      `/admin/users/${instructorId}/activity`
    );
    return mapResponseToAdminUserActivity(response.data);
  } catch (error) {
    return rejectWithValue(toApiError(error, "Failed to load the activity"));
  }
});
